export default __webpack_public_path__ + "static/media/anchovy.1888b9df.png";